module.exports = __webpack_public_path__ + "static/logos-c93f56a480726bd3a105f2226dcadcb7.pdf";